// extracted by mini-css-extract-plugin
module.exports = {"section":"MenuSection__section___tpFuY","label":"MenuSection__label___TJ6lW"};